/**
 * Hero slider de la page d'accueil (Ge-Ro).
 *
 * Swiper est chargé en global (swiper-bundle) via init_swiper() côté PHP
 * (enqueue conditionnel sur le front). On lit donc window.Swiper plutôt
 * que de l'importer dans le bundle Vite.
 */
function initHeroSlider() {
  const sliders = document.querySelectorAll('.hero-swiper');
  if (!sliders.length || typeof window.Swiper === 'undefined') {
    return false;
  }

  sliders.forEach((el) => {
    if (el.dataset.swiperInit) return;
    el.dataset.swiperInit = '1';

    new window.Swiper(el, {
      loop: el.querySelectorAll('.swiper-slide').length > 1,
      slidesPerView: 1,
      speed: 600,
      navigation: {
        prevEl: el.querySelector('.hero-prev'),
        nextEl: el.querySelector('.hero-next'),
      },
      pagination: {
        el: el.querySelector('.hero-pagination'),
        clickable: true,
      },
    });
  });

  return true;
}

function boot() {
  // window.Swiper peut être chargé après ce module : on réessaie au load.
  if (!initHeroSlider()) {
    window.addEventListener('load', initHeroSlider, { once: true });
  }
}

if (document.readyState !== 'loading') {
  boot();
} else {
  document.addEventListener('DOMContentLoaded', boot);
}
